import Vue from 'vue'
import Router from 'vue-router'

// 引入所有组件
// 导入 路由器
import page from './page';
import center from './center';
import solution from './solution';
import partner from './partner';
import my from './my'



Vue.use(Router)

export default new Router({
  routes: [
    page,
    center,
    solution,
    partner,
    my,
    {
      path:'/',
      /* 重命名进入默认的页面 */
      alias:'/a',
      redirect:'/page'
    },
    // {
    //     path:"/center",
    //     component:center,
    // },
    // {
    //     path:"/page",
    //     component:page,
    // },
    // {
    //     path:"/solution",
    //     component:solution,
    // },
    // {
    //     path:"/partner",
    //     component:partner,
    // },
    // {
    //     path:"/my",
    //     component:my,
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js